/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const GOOGLE_MAPS_API_LOCALE_STATE_KEY = 'googleMapsAPILocale';

export const GOOGLE_MAPS_API_LOCALE_BASE_STATE = { locale: '' };
